module.exports = __webpack_public_path__ + "images/simple-bg.6983eb97ec.svg";